import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFilePdf, faCheck } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';
import ExcelReportFees from './ExcelReportFees';
import ReportFeeExpensePDF from "./ReportFeeExpensePDF";
import Spinner from 'react-bootstrap/Spinner';
import AlertModal from '../../../shared/components/Modal';

const ListFeesActions = ({ data, clinicData, confirmateMedicalFee }) => {

    const [loadingConfirmation, setLoadingConfirmation] = useState(false);

    const [colorAlertModal, setColorAlertModal] = useState(false);
    const [messagAlertModal, setMessageAlertModal] = useState(false);
    const [showAlertModal, setShowAlertModal] = useState(false);

    useEffect(() => {
        console.log("dataInformation", data.data.original);
    }, []);

    const confirmMedicalFee = async () => {
        setLoadingConfirmation(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'honorarios-efectuados/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                fecha_inicial: data.data.original.fecha_inicial,
                fecha_final: data.data.original.fecha_final,
                id_profesional: data.data.original.id_profesional,
                honorarios_profesional: data.data.original.honorarios_profesional,
                subtotal: data.data.original.subtotal,
                retencion: data.data.original.retencion,
                total: data.data.original.total
            })
        }).then(response => {
            setLoadingConfirmation(false);
            if (response.status != 500 && response.status != 403) {
                setMessageAlertModal("Honorario Efectuado con Exito");
                setColorAlertModal("success");
                setShowAlertModal(true);
            }
            else {
                throw new Error('Ha ocurrido un error confirmando el Honorario');
            }
        }).catch((error) => {
            setLoadingConfirmation(false);
            setMessageAlertModal("Ha ocurrido un error confirmando el Honorario");
            setColorAlertModal("danger");
            setShowAlertModal(true);
        });
    }

    const onOkModal = () => {
        switch (colorAlertModal) {
            case "warning":
                confirmMedicalFee();
                break;
            case "success":
                setShowAlertModal(false);
                setMessageAlertModal("");
                setColorAlertModal("");
                confirmateMedicalFee(data.data.original.id_profesional);
                break;
            case "danger":
                setShowAlertModal(false);
                setMessageAlertModal("");
                setColorAlertModal("");
                break;
        }
    }

    const onToggleModal = () => {
        switch (colorAlertModal) {
            case "warning":
                setShowAlertModal(false);
                setMessageAlertModal("");
                setColorAlertModal("");
                break;
            case "success":
                setShowAlertModal(false);
                setMessageAlertModal("");
                setColorAlertModal("");
                break;
            case "danger":
                setShowAlertModal(false);
                setMessageAlertModal("");
                setColorAlertModal("");
                break;
        }
    }

    return (<Fragment>
        <td role="cell">
            <Tooltip title="Generar en Excel">
                <IconButton style={{ fontSize: '15px' }} onClick={() => ExcelReportFees.exportExcel([data.data.original], clinicData)}>
                    <FontAwesomeIcon icon={faFileExcel} />
                </IconButton>
            </Tooltip>
            <Tooltip title="Generar en PDF">
                <IconButton style={{ fontSize: '15px' }} onClick={() => ReportFeeExpensePDF(data.data.original, clinicData)}>
                    <FontAwesomeIcon icon={faFilePdf} />
                </IconButton>
            </Tooltip>
            {
                loadingConfirmation ? <Spinner style={{ width: '24px', height: '24px' }} animation="border" variant="success" /> : <Tooltip title="Confirmar Honorario">
                    <IconButton style={{ fontSize: '15px' }} onClick={() => {
                        setMessageAlertModal("Esta seguro que Confirma este Honorario Medico y que se reviso los Documentos asociados al Mismo?");
                        setColorAlertModal("warning");
                        setShowAlertModal(true);
                    }}>
                        <FontAwesomeIcon icon={faCheck} />
                    </IconButton>
                </Tooltip>
            }
        </td>

        <AlertModal
            color={colorAlertModal}
            title={messagAlertModal}
            modal={showAlertModal}
            onOk={() => onOkModal()}
            toggle={() => onToggleModal()}
        />

    </Fragment>)
}

export default ListFeesActions;